import {Tag} from 'folder-items/FileConstants';
import {mergeTemplateTags} from 'requests/templates/RequestTemplateUtil';
import {getInitialTags} from 'schemas/tags/TagUtil';
import uniqueId from 'util/uniqueId';

import {RequestTaskTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTaskTemplateGraphQL';
import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';
import {UIRequestTask} from './RequestTaskConstants';

export function genRequestTaskCid(): string {
  return uniqueId('requestTask');
}

export function makeRequestTask(schema: RequestTaskSchemaGraphQL): UIRequestTask {
  return {
    cid: genRequestTaskCid(),
    schemaId: schema.id,
    tags: getInitialTags(schema.fieldsJson) as Array<Tag>,
  };
}

export function makeRequestTaskGraphQL(schema: RequestTaskSchemaGraphQL): UIRequestTask {
  return {
    cid: genRequestTaskCid(),
    schemaId: schema.id,
    tags: getInitialTags(schema.fieldsJson) as Array<Tag>,
  };
}

export function makeRequestTaskFromTemplate(
  requestTaskSchema: RequestTaskSchemaGraphQL,
  requestTaskTemplate: RequestTaskTemplateGraphQL
): UIRequestTask {
  // We first create the task using the schema before adding template tags since template tags might
  // be sparse
  const requestTask = makeRequestTask(requestTaskSchema);
  requestTask.tags = mergeTemplateTags(requestTask.tags, requestTaskTemplate.tagsJson);
  return requestTask;
}

export function makeRequestTaskFromTemplateGraphQL(
  requestTaskSchema: RequestTaskSchemaGraphQL,
  requestTaskTemplate: RequestTaskTemplateGraphQL
): UIRequestTask {
  // We first create the task using the schema before adding template tags since template tags might
  // be sparse
  const requestTask = makeRequestTaskGraphQL(requestTaskSchema);
  requestTask.tags = mergeTemplateTags(requestTask.tags, requestTaskTemplate.tagsJson);
  return requestTask;
}
